<!-- Detailinfo.vue -->
<template>
	<div class="ui-detail-info" v-if="commonInfo">
		<div class="title">
			<span @click="$router.push({ name: 'HomeStoredetail', query: { id: commonInfo.store_id }})">{{ $t('goods_detail.store_name') }}: {{ commonInfo.store_name }}</span>
		</div>
		<div class="info-header ui-flex">
			<h3>{{ commonInfo.goods_name }}<span class="strong">{{ commonInfo.goods_advword }}</span></h3>
			<div class="favorite">
				<i class="iconfont" v-on:click="setProductUnlike" v-if="isFavorate">&#xe6d5;</i>
				<i class="iconfont" v-on:click="setProductLike" v-else>&#xe6d6;</i>
				<span style="width: 2.5rem; background-color: #EC9027; color: white;">{{favoriteName}}</span>
			</div>
		</div>

		<div class="price">
			<span class="current-price"><i class="price-number">${{ utils.currencyPrice(commonInfo.promotion_type?commonInfo.promotion_price:commonInfo.goods_price) }}</i></span>
			<span class="old-price" v-if="commonInfo.goods_marketprice > 0">${{ utils.currencyPrice(commonInfo.goods_marketprice) }}</span>
		</div>
		<div class="inviter_amount" v-if="commonInfo.inviter_money > 0">
			<span class="inviter_amount" >{{ $t('goods_detail.marketing.sell_commission') }}：${{ utils.currencyPrice(commonInfo.inviter_money) }}</span>
		</div>



				<div class="info-promotions" v-if="commonInfo.promotion_type=='xianshi'">
					<div class="left">
						<i>{{ $t('goods_detail.marketing.limited_time_offer') }}</i>
						<span v-if="commonInfo.lower_limit">{{ $t('goods_detail.marketing.lowest_limie', [commonInfo.lower_limit]) }}</span>
					</div>
					<span class="right">{{fromNow(commonInfo.promotion_end_time)}}{{ $t('goods_detail.marketing.finish_time') }}</span>
				</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { productLike, productUnlike } from '../../../../api/homegoodsdetail'

export default {
	data () {
		return {
			promotionTypeText: { 'xianshi': this.$t('goods_detail.marketing.limited_time_offer') },
			orderTime: '', // 下单时间
			arrivalsTime: '', // 到达时间
			arrivalsTitle: '', // 到达时间的标题
			arrivalsRange: '', // 到达时间区间,
			isShowDesc: false // 商品简介是否显示更多
		}
	},

	computed: {
		...mapState({
			isFavorate: state => state.goodsdetail.isFavorate,
			commonInfo: state => state.goodsdetail.commonInfo,
			// currentProductId: state => state.goodsdetail.currentProductId,
			user: state => state.member.info
		}),
		favoriteName () {
			return this.isFavorate ? this.$t('goods_detail.favorited') : this.$t('goods_detail.favorite')
		}
	},

	created () {
		this.getCurrentDate()
	},

	methods: {
		...mapMutations({
			changeIndex: 'changeIndex',
			saveIsFavorate: 'saveIsFavorate'
		}),
		fromNow (time) {
			return this.$moment(time * 1000).fromNow()
		},
		setProductLike() {
			if (!this.user) {
				Toast(this.$t('guest.need_more_please_login'))
				return
			}

			productLike()			
		},
		setProductUnlike() {
			if (!this.user) {
				Toast(this.$t('guest.need_more_please_login'))
				return
			}

			productUnlike()
		},
		/*
		 * getCommentStatus： 去到评论页面
		 */
		getCommentStatus () {
			this.changeIndex(2)
		},

		/*
				getCurrentDate: 获取当前时间
			*/
		getCurrentDate () {
			let date = new Date()
			let month = date.getMonth() + 1
			let data = date.getDate()
			let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
			this.getTimeRange(hour, minute, month, data)
		},

		/*
				getTimeRange： 获取送货时间
				@params： hour：小时  minute： 分钟  month： 月份  data： 日期
			*/
		getTimeRange (hour, minute, month, data) {
			let time = hour + '' + minute
			// 24:00 - 9:30
			if ((time >= 2400) & (time <= 930)) {
				this.orderTime = '9:30'
				this.arrivalsTitle = '当天'
				this.arrivalsTime = month + '月' + data + '日'
				this.arrivalsRange = '10:00-14:30'
			} else if ((time > 930) & (time <= 1430)) {
				// 9:30 - 14；30
				this.orderTime = '14:30'
				this.arrivalsTitle = '当天'
				this.arrivalsTime = month + '月' + data + '日'
				this.arrivalsRange = '15:00-20:00'
			} else if ((time > 1430) & (time < 1830)) {
				// 14: 30 - 18:30
				this.orderTime = '18:30'
				this.arrivalsTitle = '当天'
				this.arrivalsTime = month + '月' + data + '日'
				this.arrivalsRange = '19:00-23:00'
			} else if ((time >= 1830) & (time < 2400)) {
				// 18:30 - 24:00
				this.orderTime = '09:30'
				this.arrivalsTitle = '次日'
				this.arrivalsTime = month + '月' + (data + 1) + '日'
				this.arrivalsRange = '10:00-14:30'
			}
		},

		/*
				productLike： 收藏商品
			*/
		productLike () {
			if (this.user) {
				let id = this.commonInfo.goods_commonid
				productLike(id).then(res => {
					if (res) {
						this.saveIsFavorate(true)
						// this.getDetail()
					}
				})
				.catch(err => {
					Toast(err.message)
				})
			} else {
				this.$router.push({ name: 'HomeMemberLogin' })
			}
		},

		/*
				productUnlike： 取消收藏
			*/
		productUnlike () {
			if (this.user) {
				let id = this.commonInfo.goods_commonid
				productUnlike(id).then(res => {
					if (res) {
						this.saveIsFavorate(false)
						// this.getDetail()
					}
				})
				.catch(err => {
					Toast(err.message)
				})
			} else {
				this.$router.push({ name: 'HomeMemberLogin' })
			}
		},


		/*
				showDesc: 是否显示商品简介更多
			 */
		showDesc () {
			this.isShowDesc = !this.isShowDesc
		}
	}
}
</script>

<style lang="scss">
.ui-detail-info {
	padding: 0 0.75rem;
	background: #ffffff;
	.ui-flex {
		display: flex;
		justify-content: space-between;
		align-content: center;
		align-items: center;
		flex-basis: 100%;
		width: auto;
	}
	.title {
		padding-top: 0.4rem;
		display: flex;
		span {
			display: block;
			font-weight: lighter;
			font-size: 0.6rem;
		}
	}
	.info-header {
		padding: 0.4rem 0;
		h3 {
			color: #333;
			font-size: 1.3rem;
			padding: 0;
			margin: 0;
			font-weight: bolder;
			line-height:1rem;
			text-align: center;
    		padding-left: 2.5rem;
			width:85%;
			display: flex;
			flex-direction: column;
			.strong {
				color: $primaryColor;
				font-size: 0.7rem;
				line-height: 1.7rem;
			}
		}
		.favorite {
			height:2.4rem;
			text-align:center;
			display: flex;
			align-items: center;
			justify-content: center;
			i{width:1.3rem;display:block;font-size:1.2rem;line-height:1.2rem;color:#e93b3d;}
			span{font-size:0.5rem;line-height:1rem;height:1rem;display:block;}
		}
	}

	.price {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			display: block;
			font-weight: normal;
			&.current-price {
				font-size: 0.6rem;
				color: #EC9027;
				text-decoration: 0;
				line-height: 1rem;
				.price-number{font-size:1rem;}
			}
			&.old-price {
				font-size: 0.6rem;
				color: rgba(164, 170, 179, 1);
				line-height: 1rem;
				text-decoration: line-through;
				margin-left: 0.3rem;
			}
		}
	}
	.inviter_amount {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			font-size: .7rem;
			color: #4e545d;
		}
	}

	.info-sub {
		border-bottom: 1px solid #e8eaed;
		padding-bottom: 0.75rem;
		p {
			padding: 0;
			margin: 0;
			color: $primaryColor;
			font-size: 0.6rem;
			&.ui-clip {
				display: -webkit-box;
				overflow: hidden;
			}
		}
		img {
			width: 0.4rem;
			height: 0.2rem;
			margin-left: 0.55rem;
		}
	}

	.info-promotions {
		display: flex;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding: 0.75rem 0;
		border-bottom: 1px solid #e8eaed;
		span {
			margin-left: 0.75rem;
			font-size: 0.6rem;
			color: rgba(143, 142, 148, 1);
		}
		img {
			width: 1.9rem;
		}
	}
}
</style>
